import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import GameButtonWithText from "../GameButtonWithText";
import {GREEN_GRADIENT, RED_GRADIENT} from "../GameStyleUI";
export default class GamePopup extends React.Component {

    render() {
        let content = [];
        content.push(<div style={{
            display: "flex",
            height: "122px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px"
        }}>
            <div style={{width: "80%"}}>
                {this.props.message}
            </div>

        </div>);
        content.push(<div style={{
            height: "60px",
            display: "flex",
            width: "100%",
            justifyContent: "center",
        }}>
            {this.props.onOk ? <GameButtonWithText width={118} height={40} title={"Ок"}
                                                   colorStart={GREEN_GRADIENT[0]} colorEnd={GREEN_GRADIENT[1]}
                                                   onClick={this.props.onOk}
            /> : ""}
            {this.props.onCancel && this.props.onOk ? <div style={{width: "10px"}} /> : ""}
            {this.props.onCancel ?
                <GameButtonWithText width={118} height={40} title={"Отмена"}
                                    colorStart={RED_GRADIENT[0]} colorEnd={RED_GRADIENT[1]}
                                    onClick={this.props.onCancel}


            /> : ""}
        </div>);
        let moveStyle = {
            position: "absolute",
            left: this.props.width / 2,
            top: this.props.height / 2 - 100,
            transform: "translate(-50%,-50%)"
        }
        return <div className="in-game-popup" style={{
            position: "fixed",
            left: "60px",
            top: "60px",
            zIndex: "11",
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
        }}>
            <div style={moveStyle}>


            <GameWindowHeader width={430} height={40}
                              title={this.props.title} isClosable={true} />
            <GameWindowBg color={"#FFFFFF"} width={430} height={182} value={content}/>
            </div>
        </div>
    }
}
